module.exports = __webpack_public_path__ + "static/img/Embossing PU Processing2.e3327b78.jpg";